import { Box } from "@chakra-ui/react";

const tooltipStyles = `
  [data-tooltip]:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    top: -50px;
    left: 0;
    transform: translateX(0);
    color: #04d9ff;
    background-color: rgba(73, 72, 72, 0.9);
    padding: 8px 12px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(160, 4, 4, 0.1);
    white-space: pre-wrap;
    max-width: 300px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1;
    margin-top: 5px;
    pointer-events: none;
  }
`;

export const Tooltip = ({
  content,
  children,
}: {
  content?: string | string[];
  children: React.ReactNode;
}) => {
  const formattedContent = Array.isArray(content)
    ? content.join("\n")
    : content;

  return (
    <>
      {formattedContent ? (
        <>
          <style>{tooltipStyles}</style>
          <Box
            data-tooltip={formattedContent}
            position="relative"
            display="flex"
            justifyContent="center"
            alignItems="center"
            fontSize="xs"
            color="fg.info"
            // style={
            //   {
            //     // textOverflow: 'ellipsis',
            //   }
            // }
          >
            {children}
          </Box>
        </>
      ) : (
        children
      )}
    </>
  );
};
